import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ProgressBar from "../../../common/ProgressBar/ProgressBar";
import DownloadFile from "../../../service/DownloadFile";
import EntityConstants from "../../../configs/EntityConstants";
import DownloadRequestModal from "../../../common/DownloadRequestModal/DownloadRequestModal";
import { formatDate } from "../../../utils/formatDate";

const IssuedCredentialLongCard = (props) => {
  const {
    transaction_id,
    name,
    transaction_status,
    completed_at,
    programme_name,
    batch_name,
    receivers,
    issuance_status,
  } = props;

  const [isDownloadRequestModalOpen, setIsDownloadRequestModalOpen] =
    useState(false);
  const [downloadRequestModalMessage, setDownloadRequestModalMessage] =
    useState("");
  const [downloadRequestModalHeader, setDownloadRequestModalHeader] =
    useState("");
  const [isDownloadRequestSuccess, setIsDownloadRequestSuccess] =
    useState(false);

  const navigate = useNavigate();

  const handleDownloadZip = async (event, bulk_download = true) => {
    event.stopPropagation();
    console.log(
      "The EntityConstants.DOWNLOAD_SVG_AS_ZIP, transaction_id : ",
      EntityConstants.DOWNLOAD_SVG_AS_ZIP,
      " ",
      transaction_id
    );
    await DownloadFile(
      EntityConstants.DOWNLOAD_SVG_AS_ZIP,
      transaction_id,
      bulk_download,
      showMessageModal
    );
  };

  const showMessageModal = (isSuccess, status, message) => {
    setIsDownloadRequestSuccess(isSuccess);
    setDownloadRequestModalHeader(status);
    setDownloadRequestModalMessage(message);
    setIsDownloadRequestModalOpen(true);
  };

  const getProgressBarProps = () => {
    switch (transaction_status) {
      case "Issued":
        return {
          status: "completed",
          success: issuance_status?.total_recipients || receivers || 100,
          failed: 0,
          total: issuance_status?.total_recipients || receivers || 100,
          showPercentage: 100,
        };
      case "Revoked":
        return {
          status: "revoked",
          success: 0,
          revoked:
            issuance_status?.revoked ||
            issuance_status?.total_recipients ||
            receivers ||
            100,
          total: issuance_status?.total_recipients || receivers || 100,
          showPercentage: 100,
        };
      case "Failed":
        return {
          status: "failed",
          success: 0,
          failed:
            issuance_status?.failed ||
            issuance_status?.total_recipients ||
            receivers ||
            100,
          total: issuance_status?.total_recipients || receivers || 100,
          showPercentage: 100,
        };
      case "Deleted":
        return {
          status: "deleted",
          success: 0,
          deleted:
            issuance_status?.deleted ||
            issuance_status?.total_recipients ||
            receivers ||
            100,
          total: issuance_status?.total_recipients || receivers || 100,
          showPercentage: 100,
        };
      case "Partially Issued":
        return {
          status: "partially-issued",
          success: issuance_status?.issued || 0,
          failed: issuance_status?.failed || 0,
          revoked: issuance_status?.revoked || 0,
          deleted: issuance_status?.deleted || 0,
          total: issuance_status?.total_recipients || receivers || 1,
          showPercentage:
            issuance_status?.issued && issuance_status?.total_recipients
              ? Math.round(
                  (issuance_status.issued / issuance_status.total_recipients) *
                    100
                )
              : 0,
        };
      case "Partially Revoked":
        return {
          status: "partially-revoked",
          success: issuance_status?.issued || 0,
          failed: issuance_status?.failed || 0,
          revoked: issuance_status?.revoked || 0,
          deleted: issuance_status?.deleted || 0,
          total: issuance_status?.total_recipients || receivers || 1,
          showPercentage:
            issuance_status?.issued && issuance_status?.total_recipients
              ? Math.round(
                  (issuance_status.issued / issuance_status.total_recipients) *
                    100
                )
              : 0,
        };

      case "Partially Issued and Revoked":
        return {
          status: "partially-issued-and-revoked",
          success: issuance_status?.issued || 0,
          failed: issuance_status?.failed || 0,
          revoked: issuance_status?.revoked || 0,
          deleted: issuance_status?.deleted || 0,
          total: issuance_status?.total_recipients || receivers || 1,
          showPercentage:
            issuance_status?.issued && issuance_status?.total_recipients
              ? Math.round(
                  (issuance_status.issued / issuance_status.total_recipients) *
                    100
                )
              : 0,
        };

      case "Expired":
        return {
          status: "expired",
          success: 0,
          failed: 0,
          total: 0,
          showPercentage: 0,
        };
      case "In Progress":
        return {
          status: "in-progress",
          success: issuance_status?.issued || 0,
          failed: issuance_status?.failed || 0,
          total: issuance_status?.total_recipients || receivers || 0,
          showPercentage:
            issuance_status?.issued && issuance_status?.total_recipients
              ? Math.round(
                  (issuance_status.issued / issuance_status.total_recipients) *
                    100
                )
              : 0,
        };
      default:
        return {
          status: "default",
          success: 0,
          failed: 0,
          total: 0,
          showPercentage: 0,
        };
    }
  };

  const progressBarProps = getProgressBarProps();

  return (
    <div
      className="parent-container flex flex-row items-center border rounded-[var(--cf-issued-credential-border-radius)] py-[var(--cf-issued-credential-template-card-padding-y)] px-6 hover:bg-[#F9FAFB]"
      onClick={() =>
        navigate(`/issuer/transaction/${transaction_id}`, {
          state: { transaction_status },
        })
      }
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          navigate(`/issuer/transaction/${transaction_id}`, {
            state: { transaction_status },
          });
        }
      }}
      role="button"
      tabIndex={0}
    >
      <div className="w-1/6 text-center min-w-[150px] flex-shrink-0 overflow-hidden">
        <p className="text-cfHeadingText font-semibold whitespace-nowrap truncate">
          {name}
        </p>
        <div className="sub-container2 flex text-cfIssuedCredentialTemplateCardDateReceiversText items-center justify-center text-xs 2xl:text-sm">
          {completed_at && (
            <>
              <p className="whitespace-nowrap">{formatDate(completed_at)}</p>
              &nbsp;|&nbsp;
            </>
          )}
          {receivers > 1 && (
            <p className="whitespace-nowrap">{receivers} Receivers</p>
          )}
          {(receivers === 1 || receivers === 0) && (
            <p className="whitespace-nowrap">{receivers} Receiver</p>
          )}
        </div>
      </div>
      <div className="w-1/6 text-center min-w-[150px] flex-shrink-0 overflow-hidden">
        <p className="text-cfHeadingText truncate">{programme_name}</p>
      </div>
      <div className="w-1/6 text-center min-w-[150px] flex-shrink-0 overflow-hidden">
        <p className="text-cfHeadingText truncate">{batch_name}</p>
      </div>
      <div className="w-1/6 text-center min-w-[150px] flex-shrink-0">
        <ProgressBar {...progressBarProps} />
      </div>
      <div className="flex items-center justify-center w-1/6 min-w-[120px] flex-shrink-0 overflow-hidden">
        <div
          className={`bg-cfIssuedCredentialTemplateCardStatusDoneBG rounded-full  text-cfIssuedCredentialTemplateCardStatusText ${
            transaction_status === "Issued"
              ? "bg-cfIssuedCredentialTemplateCardStatusDoneBG"
              : transaction_status === "Revoked"
              ? "bg-cfIssuedCredentialTemplateCardStatusRevokedBG"
              : transaction_status === "Failed"
              ? "bg-cfIssuedCredentialTemplateCardStatusFailedBG"
              : transaction_status === "Expired"
              ? "bg-cfIssuedCredentialTemplateCardStatusExpiredBG"
              : transaction_status === "Partially Issued"
              ? "bg-cfIssuedCredentialTemplateCardStatusPartiallyIssuedBG"
              : transaction_status === "Partially Revoked"
              ? "bg-cfIssuedCredentialTemplateCardStatusPartiallyIssuedBG"
              : transaction_status === "Partially Issued and Revoked"
              ? "bg-cfIssuedCredentialTemplateCardStatusPartiallyIssuedBG"
              : transaction_status === "In Progress"
              ? "bg-cfIssuedCredentialTemplateCardStatusUnderReviewBG"
              : "bg-cfIssuedCredentialTemplateCardStatusText"
          }`}
        >
          <div className="text-sm text-center text-cfIssuedCredentialTemplateCardStatusText px-[0.625rem] py-[0.125rem]">
            {transaction_status}
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center w-1/6 min-w-[100px] flex-shrink-0 overflow-hidden">
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            if (receivers !== 0 && receivers >= 1) handleDownloadZip(e);
          }}
          disabled={
            receivers === 0 ||
            transaction_status === "In Progress" ||
            transaction_status === "Failed" ||
            transaction_status === "Expired"
          }
          className={`px-2 py-1 border-[1.5px] border-black rounded-full text-[0.875rem] w-fit focus:outline-none ${
            transaction_status === "In Progress" ||
            transaction_status === "Failed" ||
            transaction_status === "Expired"
              ? "opacity-50 cursor-not-allowed"
              : ""
          }`}
        >
          <p className="text-black cursor-pointer">Download</p>
        </button>
      </div>

      <DownloadRequestModal
        isOpen={isDownloadRequestModalOpen}
        header={downloadRequestModalHeader}
        isSuccess={isDownloadRequestSuccess}
        message={downloadRequestModalMessage}
        onClose={() => setIsDownloadRequestModalOpen(false)}
      />
    </div>
  );
};

export default IssuedCredentialLongCard;
